import { fetchQuery } from '@/services/messaging/fetchQuery';
import { assignFeatureFlag } from '@/directives/FeatureFlags.js'

export function getCurrentUserIdentity() {
  var response = fetchQuery("GetCurrentUserIdentity", {}).then((response) => { assignFeatureFlag(response); return response });
  return response;
}
